import nlcToken from '../abis/development/tokens/nlcToken';

export default {
  name: 'NLTEST',
  abi: nlcToken.abi,
  contractAddress: '0x963bcf925014daC621EfAc2A0E6d1B272642d351',
  decimals: 18,
};
